@let resultValue = result();

@if (resultValue) {
  @if (resultValue.status) {
    <div class="flex w-full justify-center items-center pb-5">
      <app-task-state class="text-3xl" [state]="resultValue.status"></app-task-state>
    </div>
  }

  <div class="compatibility flex justify-center gap-3 h-fit flex-wrap">
    @if (resultValue.device) {
      <app-compatibility-card
        class="flex-1/4 max-h-full grow min-w-75 mb-8"
        icon="desktop"
        [label]="resultValue.device.type | titlecase"
        [compatibility]="resultValue.device.compatibility" />
    }

    @if (resultValue.browser) {
      <app-compatibility-card
        class="flex-1/4 max-h-full grow min-w-75 mb-8"
        icon="browser"
        [label]="resultValue.browser.type | titlecase"
        [description]="resultValue.device?.platform || ''"
        [compatibility]="resultValue.browser.compatibility" />
    }

    @if (resultValue.webRtc) {
      <app-compatibility-card
        class="flex-1/4 max-h-full grow min-w-75 mb-8"
        icon="video"
        label="Video"
        [compatibility]="resultValue.webRtc.compatibility" />
    }
  </div>

  <hr />
}

<app-audio-level></app-audio-level>

<hr />

@if (resultValue && resultValue.services) {
  <table class="bg-white rounded-md border-collapse mt-8 desktop w-full text-left">
    <thead>
      <tr class="border-b border-gray-300 w-full">
        <th class="font-bold p-4">Service</th>
        <th class="font-bold p-4">Description</th>
        <th class="font-bold p-4">Statut</th>
      </tr>
    </thead>
    <tbody>
      <tr class="border-b border-gray-300 relative">
        @let websocket = resultValue.services.websocket;
        <td class="p-4">Medinbox Link WSS</td>
        <td class="p-4">TCP 443</td>
        <td class="p-4">
          <app-task-state [state]="websocket.status" [label]="websocket.reason"></app-task-state>
        </td>
      </tr>
      <tr class="border-b border-gray-300 relative">
        @let link = resultValue.services.link;
        <td class="p-4">Medinbox Link Service</td>
        <td class="p-4">API, REST, Session</td>
        <td class="p-4">
          <app-task-state [state]="link.status" [label]="link.reason"></app-task-state>
        </td>
      </tr>
      <tr class="border-b border-gray-300 relative">
        @let video = resultValue.services.video;
        <td class="p-4">Medinbox video Service</td>
        <td class="p-4">API, REST, Prerequisite</td>
        <td class="p-4">
          <app-task-state [state]="video.status" [label]="video.reason"></app-task-state>
        </td>
      </tr>
    </tbody>
  </table>
}
